module.exports = __webpack_public_path__ + "static/img/lifestyle_09.4786398d.jpg";